<template>
  <v-container fluid class="pa-12" style="max-width: 1344px;">
    <v-row align="start" justify="center" class="px-12">
      <v-col cols="12">
        <v-card class="elevation-5">
          <v-data-table
            :headers="headers"
            :items="tags"
            sort-by="workerId"
            class="elevation-1"
            :loading="loading"
            loading-text="Loading... Please wait"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Worker</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn to="/hr_new_worker" color="primary" dark class="mb-2"
                  >New Worker</v-btn
                >
              </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon small class="mr-2" @click="sendMessage(item)"
                >edit</v-icon
              >
              <v-icon small>delete</v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'

export default {
  name: 'worker_type',
  data: () => ({
    parentmessage: '',
    search: '',
    dialog: false,
    loading: true,
    hide: true,
    headers: [
      { text: 'WORKER ID', value: 'workerId' },
      { text: 'FIRST NAME', value: 'firstname' },
      { text: 'LAST NAME', value: 'lastname' },
      { text: 'FIN', value: 'fin' },
      { text: 'NATIONALITY', value: 'nationality' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    tags: [],
    editedIndex: -1,
    editedItem: {
      workertypeId: 0,
      workertypename: ''
    },
    defaultItem: {
      workertypename: ''
    }
  }),
  created() {
    this.initialize()
  },
  methods: {
    sendMessage(item) {
      this.$router.push({
        name: 'hr_view_worker',
        params: { id: item.workerId }
      })
    },
    initialize() {
      ApiService.get('/Worker')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.tags = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
